import { PatientShareScansModelViewer } from '../../../patient/patient-share/PatientShareScansModelViewer';
import type { FragmentType } from '@orthly/graphql-inline-react';
import {
    getFragmentData,
    OrderDesignPreviewDesignModelPayloadsScanExport_FragmentFragmentDoc,
} from '@orthly/graphql-inline-react';
import { FlossPalette } from '@orthly/ui';
import { styled, Text } from '@orthly/ui-primitives';
import React from 'react';

const ScanPlaceholder = styled('div')({
    width: '100%',
    height: '100%',
    background: FlossPalette.WHITE,
    borderRadius: '16px',
    border: `1px solid ${FlossPalette.STROKE_LIGHT}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

interface PatientDetailModelViewerProps {
    selectedScanExportFragment:
        | FragmentType<typeof OrderDesignPreviewDesignModelPayloadsScanExport_FragmentFragmentDoc>
        | undefined
        | null;
    loading: boolean;
}

export const PatientDetailModelViewer: React.VFC<PatientDetailModelViewerProps> = props => {
    const { selectedScanExportFragment, loading } = props;

    if (!selectedScanExportFragment) {
        return (
            <ScanPlaceholder>
                {!loading && (
                    <Text variant={'body1'} medium color={'LIGHT_GRAY'}>
                        Select a scan to get started.
                    </Text>
                )}
            </ScanPlaceholder>
        );
    }

    const selectedScanExport = getFragmentData(
        OrderDesignPreviewDesignModelPayloadsScanExport_FragmentFragmentDoc,
        selectedScanExportFragment,
    );

    if (selectedScanExport.assets?.length === 0) {
        return (
            <ScanPlaceholder>
                <Text variant={'body1'} medium color={'LIGHT_GRAY'}>
                    Hmm, we're having trouble loading this scan.
                </Text>
            </ScanPlaceholder>
        );
    }

    return (
        <PatientShareScansModelViewer
            background={FlossPalette.WHITE}
            height={'100%'}
            scanExportFragment={selectedScanExportFragment}
        />
    );
};
